document.addEventListener('click', (event) => {
  const button = event.target.closest('.i_minus_cart, .i_plus_cart');
  if (!button) return;

  event.preventDefault();

  const input = button.closest('.customquantwrapper')?.querySelector('.quantity-input');
  if (!input) return;

  const step = parseFloat(input.step) || 1;
  const min = input.min !== '' ? parseFloat(input.min) : 1;
  const max = input.max !== '' ? parseFloat(input.max) : Infinity;
  const current = parseFloat(input.value) || min;

  const next = button.classList.contains('i_plus_cart') ? current + step : current - step;
  const clamped = Math.min(Math.max(next, min), max);

  if (clamped === current) return;

  input.value = clamped;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});